
export const checkRequired = (params: object, fieldKey: string) => {
  if (!params[fieldKey]) {
    console.warn(`[checkRequired]=== ${fieldKey} is required! ===`);
    return false;
  }
  return true;
};

/** 接口预校验 */
export const isPassPreCheck = (qryParams: object, needCheckFields: string[] = []) => {
  let isSuccess = true;
  needCheckFields.forEach((item) => {
    if (!checkRequired(qryParams || {}, item)) {
      isSuccess = false;
    }
  });
  return isSuccess;
};
